import { useState, useEffect } from 'react';
import { statesByCountry } from './locationData';

interface GeolocationState {
  country?: string;
  state?: string;
  loading: boolean;
  error?: string;
}

export function useGeolocation() {
  const [location, setLocation] = useState<GeolocationState>({
    loading: true
  });

  useEffect(() => {
    const detectLocation = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        
        // Include state if country has states defined
        const hasStates = data.country && statesByCountry[data.country];
        
        setLocation({
          country: data.country,
          state: hasStates ? data.region_code : undefined,
          loading: false
        });
      } catch (error) {
        setLocation({
          loading: false,
          error: 'Failed to detect location'
        });
      }
    };

    detectLocation();
  }, []);

  return location;
}